import React, { useMemo } from 'react';
import styles from './deleteModal.module.scss';
import { Unit, Lesson } from '../../../../types';
import Modal from '../../../../components/modal/Modal';
import Button from '../../../../components/button/Button';

type Props = {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onDelete: () => void;
  unit?: Unit;
  lesson?: Lesson;
  isHomeEd?: boolean;
};

function DeleteModal(props: Props) {
  const { open, loading, onClose, onDelete, unit, lesson, isHomeEd } = props;

  const handleClose = () => {
    onClose();
  };

  const handleDelete = () => {
    onDelete();
  }

  const isUnit = useMemo(() => !!unit, [unit]);
  const isLesson = useMemo(() => !!lesson, [lesson]);
  const message = useMemo(() => `Do you really want to ${(isUnit && (isHomeEd ? "Delete HomeEd Unit" : "Delete Unit")) || (isLesson && "Delete Lesson")}`, [isHomeEd, isLesson, isUnit]);

  return (
    <Modal open={open} onClose={handleClose}>
      <div>
        <div className={styles.title}>{message}</div>
          <div className={styles.content}>
            <div className={styles.action}>
              <Button className={styles.cancelButton} disabled={loading} onClick={handleClose} label={'CANCEL'}/>
              <Button className={styles.deleteButton} disabled={loading} isLoading={loading} onClick={handleDelete} label={'CONFIRM DELETION'}/>
            </div>
          </div>
      </div>
    </Modal>
  );
}

export default DeleteModal;
